import { toast } from "react-toastify";
import { clearIndexDB } from "../db";
import { setLogout } from "../redux/actions/actions";
import store from "../redux/store/store";

export const handleLogoutForUnAuth = async () => {
  try {
    localStorage.setItem("ShowTradeModal", false);
    await clearIndexDB();
    store.dispatch(setLogout());
    toast.error("Your Session Has Been Ended");
  } catch (error) {
    console.error("handleLogoutForUnAuth-> Error while logging out:", error);
  } finally {
    window.location.href = "/";
  }
};
